import { Component } from '@angular/core';

@Component({
  selector: 'app-active-standards',
  standalone: false,
  templateUrl: './active-standards.component.html',
  styleUrl: './active-standards.component.scss'
})
export class ActiveStandardsComponent {
  ActiveStandardsurl: string = 'https://surface-prod.crm.dynamics.com/main.aspx?appid=41dc17ce-7109-f011-bae4-6045bd084d01&pagetype=entitylist&etn=new_waterdisposalrecords&viewid=76568a48-252e-44ab-8c2e-43a2ab4aaeab&viewType=1039&lid=1744101232198';


}
